import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getRepairStatuses = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/repair-status`);
    return response.data;
  } catch (error) {
    console.error('Error fetching repair statuses:', error.response?.data || error);
    throw error;
  }
};

export const getRepairStatusById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/repair-status/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching repair status:', error.response?.data || error);
    throw error;
  }
};

export const createRepairStatus = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/repair-status`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating repair status:', error.response?.data || error);
    throw error;
  }
};

export const updateRepairStatus = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/repair-status/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating repair status:', error.response?.data || error);
    throw error;
  }
};

export const deleteRepairStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/repair-status/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting repair status:', error.response?.data || error);
    throw error;
  }
};
